import { PublicationType } from "generated/CoreApi_v1";
import * as React from 'react';
import { useTranslation } from 'react-i18next';

export const PublicationTypeName: React.FC<{ publicationType: PublicationType; }> = (props) => {
    const { t } = useTranslation();
    if (props.publicationType == null || (props.publicationType as number) == 0) return null;
    return <span>{t(`Enums.PublicationType.${PublicationType[props.publicationType]}`)}</span>;
};

